// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Camadas, feições, inspetor, legenda compacta e popup do mapa. */

/* --- Camadas cartográficas ----------------------------------------------- */

.camadas {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
}

.camadas__item {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
  padding: 3px 0;
  border-bottom: 1px solid transparent;
}

.camadas__linha {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: var(--espaco-2);
  min-height: 28px;
}

.camadas__checkbox {
  width: 13px;
  height: 13px;
  accent-color: var(--realce);
}

.amostra--vazia {
  background: transparent;
  border-color: transparent;
}

.camadas__nome {
  flex: none;
  min-width: 0;
  text-align: left;
  background: none;
  border: none;
  padding: 0;
  color: var(--tinta);
  font: inherit;
  font-size: var(--texto-sm);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.camadas__nome:hover {
  color: var(--realce);
}

.camadas__contagem {
  flex: none;
  color: var(--tinta-suave);
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  font-variant-numeric: tabular-nums;
}

.camadas__expandir {
  transition: transform var(--transicao);
}

.camadas__item[data-expandido='sim'] .camadas__expandir {
  transform: rotate(90deg);
}

.camadas__expansao {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
  padding: var(--espaco-2) 0 var(--espaco-2) calc(13px + var(--espaco-2) + 16px + var(--espaco-2));
  border-left: 2px solid var(--linha);
  margin-left: 6px;
}

.camadas__acoes {
  display: flex;
  flex-wrap: wrap;
  gap: var(--espaco-2);
}

.camadas__alternador {
  display: flex;
  align-items: center;
  gap: var(--espaco-2);
  min-width: 0;
  font-size: var(--texto-sm);
  cursor: pointer;
}

.camadas__alternador:has(input:disabled) {
  color: var(--tinta-suave);
  cursor: default;
}

.camadas__alternador input {
  flex: none;
  width: 13px;
  height: 13px;
  accent-color: var(--realce);
}

.camadas__contagem {
  margin-left: auto;
  flex: none;
  color: var(--tinta-suave);
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  font-variant-numeric: tabular-nums;
}

/* Amostra de simbologia: o mesmo traço e preenchimento usados no mapa. */
.amostra {
  flex: none;
  width: 16px;
  height: 11px;
  border-radius: 2px;
  border: 1.5px solid var(--traco, var(--tinta-suave));
  background: var(--preenchimento, transparent);
}

.amostra--linha {
  height: 0;
  border-width: 0;
  border-top-width: 1.5px;
  border-radius: 0;
  border-top-style: var(--estilo-traco, solid);
}

.amostra--ponto {
  width: 11px;
  height: 11px;
  margin: 0 2.5px;
  border-radius: 50%;
  background: var(--traco, var(--tinta-suave));
  border: 1.5px solid #fff;
  box-shadow: 0 0 0 1px var(--traco, var(--tinta-suave));
}

/* --- Lista de feições ---------------------------------------------------- */

.feicoes {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--linha);
}

.feicoes__item {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--espaco-2);
  width: 100%;
  padding: var(--espaco-2) var(--espaco-3);
  background: none;
  border: none;
  border-left: 2px solid transparent;
  border-bottom: 1px solid var(--linha);
  text-align: left;
  cursor: pointer;
  transition:
    background var(--transicao),
    border-color var(--transicao);
}

.feicoes li:last-child .feicoes__item {
  border-bottom: none;
}

.feicoes__item:hover {
  background: var(--papel-2);
}

.feicoes__item[data-selecionado='sim'] {
  background: var(--realce-fraco);
  border-left-color: var(--pena-selecao);
}

.feicoes__texto {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.feicoes__titulo {
  font-size: var(--texto-sm);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feicoes__detalhe {
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

.feicoes__valor {
  flex: none;
  color: var(--tinta-media);
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  font-variant-numeric: tabular-nums;
}

.feicoes__item--estatico,
.feicoes__item--estatico:hover {
  cursor: default;
  background: none;
}

/* --- Inspetor da entidade ------------------------------------------------ */

.inspetor__cabecalho {
  flex: none;
  display: flex;
  align-items: flex-start;
  gap: var(--espaco-2);
  padding: var(--espaco-3);
  border-bottom: 1px solid var(--linha);
}

.inspetor__pena {
  flex: none;
  width: 3px;
  align-self: stretch;
  border-radius: 2px;
  background: var(--pena-selecao);
}

.inspetor__identificacao {
  min-width: 0;
  flex: 1 1 auto;
}

.inspetor__tipo {
  display: block;
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  letter-spacing: 0.02em;
}

.inspetor__nome {
  font-size: var(--texto-lg);
  font-weight: 600;
  line-height: 1.25;
}

.inspetor__medida {
  display: block;
  margin-top: 2px;
  color: var(--tinta-media);
  font-family: var(--fonte-dados);
  font-size: var(--texto-sm);
  font-variant-numeric: tabular-nums;
}

.inspetor__abas {
  flex: none;
  display: flex;
  gap: var(--espaco-3);
  padding: 0 var(--espaco-3);
  border-bottom: 1px solid var(--linha);
}

.inspetor__aba {
  padding: var(--espaco-2) 0;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--tinta-suave);
  font-size: var(--texto-sm);
  cursor: pointer;
  transition: color var(--transicao);
}

.inspetor__aba:hover {
  color: var(--tinta);
}

.inspetor__aba[aria-selected='true'] {
  border-bottom-color: var(--realce);
  color: var(--tinta);
  font-weight: 600;
}

.inspetor__corpo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--espaco-3);
  display: flex;
  flex-direction: column;
  gap: var(--espaco-3);
}

/* --- Ficha de atributos -------------------------------------------------- */

.ficha {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
}

.ficha__linha {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--espaco-3);
}

.ficha dt {
  flex: none;
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

.ficha dd {
  margin: 0;
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  text-align: right;
  word-break: break-all;
}

/* --- Legenda compacta ---------------------------------------------------- */

.legenda {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
  padding: var(--espaco-2) var(--espaco-3);
  background: var(--papel);
  border: 1px solid var(--linha);
  border-radius: var(--raio-grande);
  box-shadow: var(--sombra-flutuante);
}

.legenda__item {
  display: inline-flex;
  align-items: center;
  gap: var(--espaco-2);
  font-size: var(--texto-xs);
  color: var(--tinta-media);
  white-space: nowrap;
}

/* --- Popup do mapa ------------------------------------------------------- */

.popup__titulo {
  margin-bottom: var(--espaco-2);
  font-size: var(--texto-sm);
  font-weight: 600;
}

.popup__linha {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--espaco-4);
}

.popup__rotulo {
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
}

.popup__valor {
  font-family: var(--fonte-dados);
  font-size: var(--texto-xs);
  text-align: right;
  word-break: break-all;
}

/* --- Estado da camada no catálogo ---------------------------------------- */

.camadas__item[data-selecionado='sim'] .camadas__nome {
  font-weight: 600;
}

.camadas__falha {
  flex: none;
  color: var(--erro);
  font-size: var(--texto-xs);
}

.seletor-de-feicoes {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
}

.seletor-de-feicoes__topo {
  display: flex;
  align-items: center;
}

.feicoes__item--selecionavel {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: start;
  column-gap: var(--espaco-2);
  cursor: default;
}

.feicoes__item--selecionavel input {
  margin-top: 2px;
  flex: none;
  accent-color: var(--realce);
}

.feicoes__item--selecionavel .feicoes__texto {
  min-width: 0;
  text-align: left;
}

.feicoes__item--selecionavel .feicoes__titulo {
  display: block;
  text-align: left;
}

.feicoes__item--selecionavel .feicoes__detalhe {
  display: block;
  text-align: left;
}

.configuracao-da-camada {
  display: flex;
  flex-wrap: wrap;
  gap: var(--espaco-3);
  padding: var(--espaco-2) 0;
  border-top: 1px solid var(--linha);
  border-bottom: 1px solid var(--linha);
}

.configuracao-da-camada__grupo {
  display: flex;
  flex-wrap: wrap;
  gap: var(--espaco-2);
  align-items: center;
  border: none;
  padding: 0;
  margin: 0;
}

.configuracao-da-camada__grupo legend {
  flex: none;
  color: var(--tinta-suave);
  font-size: var(--texto-xs);
  letter-spacing: 0.02em;
  padding: 0;
}

.configuracao-da-camada__campo {
  display: inline-flex;
  align-items: center;
}

.configuracao-da-camada__campo input[type='color'] {
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1px solid var(--linha);
  border-radius: var(--raio);
  background: transparent;
}

.configuracao-da-camada__campo input[type='range'] {
  width: 80px;
}

.relevo__controles {
  display: flex;
  align-items: center;
  gap: var(--espaco-3);
}

.botao--texto {
  background: none;
  border: none;
  padding: 0;
  color: var(--realce);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  font-size: var(--texto-xs);
}

.ficha__json {
  margin: 0;
  max-width: 100%;
  overflow-x: auto;
  text-align: left;
  white-space: pre-wrap;
}

.sr-apenas {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.painel-de-camada {
  display: flex;
  flex-direction: column;
  gap: var(--espaco-2);
}
`, "",{"version":3,"sources":["webpack://./src/styles/listas.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE,8EAA8E;;AAE9E;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gGAAgG;EAChG,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;EACpD,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,4CAA4C;EAC5C,wBAAwB;EACxB,sDAAsD;AACxD;;AAEA,8EAA8E;;AAE9E;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf;;iCAE+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,8EAA8E;;AAE9E;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,8EAA8E;;AAE9E;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB","sourcesContent":["/* Camadas, feições, inspetor, legenda compacta e popup do mapa. */\r\n\r\n/* --- Camadas cartográficas ----------------------------------------------- */\r\n\r\n.camadas {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.camadas__item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n  padding: 3px 0;\r\n  border-bottom: 1px solid transparent;\r\n}\r\n\r\n.camadas__linha {\r\n  display: grid;\r\n  grid-template-columns: auto auto minmax(0, 1fr) auto auto;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  min-height: 28px;\r\n}\r\n\r\n.camadas__checkbox {\r\n  width: 13px;\r\n  height: 13px;\r\n  accent-color: var(--realce);\r\n}\r\n\r\n.amostra--vazia {\r\n  background: transparent;\r\n  border-color: transparent;\r\n}\r\n\r\n.camadas__nome {\r\n  flex: none;\r\n  min-width: 0;\r\n  text-align: left;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: var(--tinta);\r\n  font: inherit;\r\n  font-size: var(--texto-sm);\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.camadas__nome:hover {\r\n  color: var(--realce);\r\n}\r\n\r\n.camadas__contagem {\r\n  flex: none;\r\n  color: var(--tinta-suave);\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.camadas__expandir {\r\n  transition: transform var(--transicao);\r\n}\r\n\r\n.camadas__item[data-expandido='sim'] .camadas__expandir {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.camadas__expansao {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-2) 0 var(--espaco-2) calc(13px + var(--espaco-2) + 16px + var(--espaco-2));\r\n  border-left: 2px solid var(--linha);\r\n  margin-left: 6px;\r\n}\r\n\r\n.camadas__acoes {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n.camadas__alternador {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  min-width: 0;\r\n  font-size: var(--texto-sm);\r\n  cursor: pointer;\r\n}\r\n\r\n.camadas__alternador:has(input:disabled) {\r\n  color: var(--tinta-suave);\r\n  cursor: default;\r\n}\r\n\r\n.camadas__alternador input {\r\n  flex: none;\r\n  width: 13px;\r\n  height: 13px;\r\n  accent-color: var(--realce);\r\n}\r\n\r\n.camadas__contagem {\r\n  margin-left: auto;\r\n  flex: none;\r\n  color: var(--tinta-suave);\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* Amostra de simbologia: o mesmo traço e preenchimento usados no mapa. */\r\n.amostra {\r\n  flex: none;\r\n  width: 16px;\r\n  height: 11px;\r\n  border-radius: 2px;\r\n  border: 1.5px solid var(--traco, var(--tinta-suave));\r\n  background: var(--preenchimento, transparent);\r\n}\r\n\r\n.amostra--linha {\r\n  height: 0;\r\n  border-width: 0;\r\n  border-top-width: 1.5px;\r\n  border-radius: 0;\r\n  border-top-style: var(--estilo-traco, solid);\r\n}\r\n\r\n.amostra--ponto {\r\n  width: 11px;\r\n  height: 11px;\r\n  margin: 0 2.5px;\r\n  border-radius: 50%;\r\n  background: var(--traco, var(--tinta-suave));\r\n  border: 1.5px solid #fff;\r\n  box-shadow: 0 0 0 1px var(--traco, var(--tinta-suave));\r\n}\r\n\r\n/* --- Lista de feições ---------------------------------------------------- */\r\n\r\n.feicoes {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  border-top: 1px solid var(--linha);\r\n}\r\n\r\n.feicoes__item {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-2);\r\n  width: 100%;\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  background: none;\r\n  border: none;\r\n  border-left: 2px solid transparent;\r\n  border-bottom: 1px solid var(--linha);\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition:\r\n    background var(--transicao),\r\n    border-color var(--transicao);\r\n}\r\n\r\n.feicoes li:last-child .feicoes__item {\r\n  border-bottom: none;\r\n}\r\n\r\n.feicoes__item:hover {\r\n  background: var(--papel-2);\r\n}\r\n\r\n.feicoes__item[data-selecionado='sim'] {\r\n  background: var(--realce-fraco);\r\n  border-left-color: var(--pena-selecao);\r\n}\r\n\r\n.feicoes__texto {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  min-width: 0;\r\n}\r\n\r\n.feicoes__titulo {\r\n  font-size: var(--texto-sm);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.feicoes__detalhe {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.feicoes__valor {\r\n  flex: none;\r\n  color: var(--tinta-media);\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.feicoes__item--estatico,\r\n.feicoes__item--estatico:hover {\r\n  cursor: default;\r\n  background: none;\r\n}\r\n\r\n/* --- Inspetor da entidade ------------------------------------------------ */\r\n\r\n.inspetor__cabecalho {\r\n  flex: none;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: var(--espaco-2);\r\n  padding: var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.inspetor__pena {\r\n  flex: none;\r\n  width: 3px;\r\n  align-self: stretch;\r\n  border-radius: 2px;\r\n  background: var(--pena-selecao);\r\n}\r\n\r\n.inspetor__identificacao {\r\n  min-width: 0;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.inspetor__tipo {\r\n  display: block;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.inspetor__nome {\r\n  font-size: var(--texto-lg);\r\n  font-weight: 600;\r\n  line-height: 1.25;\r\n}\r\n\r\n.inspetor__medida {\r\n  display: block;\r\n  margin-top: 2px;\r\n  color: var(--tinta-media);\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-sm);\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.inspetor__abas {\r\n  flex: none;\r\n  display: flex;\r\n  gap: var(--espaco-3);\r\n  padding: 0 var(--espaco-3);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.inspetor__aba {\r\n  padding: var(--espaco-2) 0;\r\n  background: none;\r\n  border: none;\r\n  border-bottom: 2px solid transparent;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-sm);\r\n  cursor: pointer;\r\n  transition: color var(--transicao);\r\n}\r\n\r\n.inspetor__aba:hover {\r\n  color: var(--tinta);\r\n}\r\n\r\n.inspetor__aba[aria-selected='true'] {\r\n  border-bottom-color: var(--realce);\r\n  color: var(--tinta);\r\n  font-weight: 600;\r\n}\r\n\r\n.inspetor__corpo {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: var(--espaco-3);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n/* --- Ficha de atributos -------------------------------------------------- */\r\n\r\n.ficha {\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n.ficha__linha {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n.ficha dt {\r\n  flex: none;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.ficha dd {\r\n  margin: 0;\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  text-align: right;\r\n  word-break: break-all;\r\n}\r\n\r\n/* --- Legenda compacta ---------------------------------------------------- */\r\n\r\n.legenda {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-2) var(--espaco-3);\r\n  background: var(--papel);\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio-grande);\r\n  box-shadow: var(--sombra-flutuante);\r\n}\r\n\r\n.legenda__item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: var(--espaco-2);\r\n  font-size: var(--texto-xs);\r\n  color: var(--tinta-media);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* --- Popup do mapa ------------------------------------------------------- */\r\n\r\n.popup__titulo {\r\n  margin-bottom: var(--espaco-2);\r\n  font-size: var(--texto-sm);\r\n  font-weight: 600;\r\n}\r\n\r\n.popup__linha {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: var(--espaco-4);\r\n}\r\n\r\n.popup__rotulo {\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.popup__valor {\r\n  font-family: var(--fonte-dados);\r\n  font-size: var(--texto-xs);\r\n  text-align: right;\r\n  word-break: break-all;\r\n}\r\n\r\n/* --- Estado da camada no catálogo ---------------------------------------- */\r\n\r\n.camadas__item[data-selecionado='sim'] .camadas__nome {\r\n  font-weight: 600;\r\n}\r\n\r\n.camadas__falha {\r\n  flex: none;\r\n  color: var(--erro);\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.seletor-de-feicoes {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n}\r\n\r\n.seletor-de-feicoes__topo {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.feicoes__item--selecionavel {\r\n  display: grid;\r\n  grid-template-columns: auto minmax(0, 1fr) auto;\r\n  align-items: start;\r\n  column-gap: var(--espaco-2);\r\n  cursor: default;\r\n}\r\n\r\n.feicoes__item--selecionavel input {\r\n  margin-top: 2px;\r\n  flex: none;\r\n  accent-color: var(--realce);\r\n}\r\n\r\n.feicoes__item--selecionavel .feicoes__texto {\r\n  min-width: 0;\r\n  text-align: left;\r\n}\r\n\r\n.feicoes__item--selecionavel .feicoes__titulo {\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n.feicoes__item--selecionavel .feicoes__detalhe {\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n.configuracao-da-camada {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--espaco-3);\r\n  padding: var(--espaco-2) 0;\r\n  border-top: 1px solid var(--linha);\r\n  border-bottom: 1px solid var(--linha);\r\n}\r\n\r\n.configuracao-da-camada__grupo {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--espaco-2);\r\n  align-items: center;\r\n  border: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.configuracao-da-camada__grupo legend {\r\n  flex: none;\r\n  color: var(--tinta-suave);\r\n  font-size: var(--texto-xs);\r\n  letter-spacing: 0.02em;\r\n  padding: 0;\r\n}\r\n\r\n.configuracao-da-camada__campo {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.configuracao-da-camada__campo input[type='color'] {\r\n  width: 22px;\r\n  height: 22px;\r\n  padding: 0;\r\n  border: 1px solid var(--linha);\r\n  border-radius: var(--raio);\r\n  background: transparent;\r\n}\r\n\r\n.configuracao-da-camada__campo input[type='range'] {\r\n  width: 80px;\r\n}\r\n\r\n.relevo__controles {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--espaco-3);\r\n}\r\n\r\n.botao--texto {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: var(--realce);\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n  cursor: pointer;\r\n  font-size: var(--texto-xs);\r\n}\r\n\r\n.ficha__json {\r\n  margin: 0;\r\n  max-width: 100%;\r\n  overflow-x: auto;\r\n  text-align: left;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.sr-apenas {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.painel-de-camada {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--espaco-2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
